'use strict';

var _regeneratorRuntime = require("/codebuild/output/src4034036480/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _slicedToArray = require("/codebuild/output/src4034036480/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var _classCallCheck = require("/codebuild/output/src4034036480/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/codebuild/output/src4034036480/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var map = new WeakMap();

var wm = function wm(o) {
  return map.get(o);
};

var normalizeValue = function normalizeValue(v) {
  return typeof v === 'string' ? v : String(v);
};

var isIterable = function isIterable(o) {
  return o != null && typeof o[Symbol.iterator] === 'function';
};

function normalizeName(name) {
  if (typeof name !== 'string') name = String(name);
  if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) throw new TypeError('Invalid character in header field name');
  return name.toLowerCase();
}

var Headers =
/*#__PURE__*/
function () {
  /**
   * Headers class
   *
   * @param   Object  headers  Response headers
   * @return  Void
   */
  function Headers(headers) {
    _classCallCheck(this, Headers);

    map.set(this, Object.create(null));

    if (isIterable(headers)) {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = headers[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var _step$value = _slicedToArray(_step.value, 2),
              name = _step$value[0],
              value = _step$value[1];

          this.append(name, value);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return != null) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    } else if (headers) {
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = Object.getOwnPropertyNames(headers)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var name = _step2.value;
          this.append(name, headers[name]);
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }
    }
  }
  /**
   * Append a value onto existing header
   *
   * @param   String  name   Header name
   * @param   String  value  Header value
   * @return  Void
   */


  _createClass(Headers, [{
    key: "append",
    value: function append(name, value) {
      var map = wm(this);
      name = normalizeName(name);
      value = normalizeValue(value);
      if (!map[name]) map[name] = [];
      map[name].push(value);
    }
    /**
     * Delete all header values given name
     *
     * @param   String  name  Header name
     * @return  Void
     */

  }, {
    key: "delete",
    value: function _delete(name) {
      delete wm(this)[normalizeName(name)];
    }
    /**
     * Iterate over all headers as [name, value]
     *
     * @return  Iterator
     */

  }, {
    key: "entries",
    value:
    /*#__PURE__*/
    _regeneratorRuntime.mark(function entries() {
      var map, name;
      return _regeneratorRuntime.wrap(function entries$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              map = wm(this);
              _context.t0 = _regeneratorRuntime.keys(map);

            case 2:
              if ((_context.t1 = _context.t0()).done) {
                _context.next = 8;
                break;
              }

              name = _context.t1.value;
              _context.next = 6;
              return [name, map[name].join(',')];

            case 6:
              _context.next = 2;
              break;

            case 8:
            case "end":
              return _context.stop();
          }
        }
      }, entries, this);
    })
    /**
     * Return first header value given name
     *
     * @param   String  name  Header name
     * @return  Mixed
     */

  }, {
    key: "get",
    value: function get(name) {
      var map = wm(this);
      name = normalizeName(name);
      return map[name] ? map[name][0] : null;
    }
    /**
     * Check for header name existence
     *
     * @param   String   name  Header name
     * @return  Boolean
     */

  }, {
    key: "has",
    value: function has(name) {
      return normalizeName(name) in wm(this);
    }
    /**
     * Iterate over all keys
     *
     * @return  Iterator
     */

  }, {
    key: "keys",
    value:
    /*#__PURE__*/
    _regeneratorRuntime.mark(function keys() {
      var _iteratorNormalCompletion3, _didIteratorError3, _iteratorError3, _iterator3, _step3, _step3$value, name;

      return _regeneratorRuntime.wrap(function keys$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _iteratorNormalCompletion3 = true;
              _didIteratorError3 = false;
              _iteratorError3 = undefined;
              _context2.prev = 3;
              _iterator3 = this[Symbol.iterator]();

            case 5:
              if (_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done) {
                _context2.next = 12;
                break;
              }

              _step3$value = _slicedToArray(_step3.value, 1), name = _step3$value[0];
              _context2.next = 9;
              return name;

            case 9:
              _iteratorNormalCompletion3 = true;
              _context2.next = 5;
              break;

            case 12:
              _context2.next = 18;
              break;

            case 14:
              _context2.prev = 14;
              _context2.t0 = _context2["catch"](3);
              _didIteratorError3 = true;
              _iteratorError3 = _context2.t0;

            case 18:
              _context2.prev = 18;
              _context2.prev = 19;

              if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
                _iterator3.return();
              }

            case 21:
              _context2.prev = 21;

              if (!_didIteratorError3) {
                _context2.next = 24;
                break;
              }

              throw _iteratorError3;

            case 24:
              return _context2.finish(21);

            case 25:
              return _context2.finish(18);

            case 26:
            case "end":
              return _context2.stop();
          }
        }
      }, keys, this, [[3, 14, 18, 26], [19,, 21, 25]]);
    })
    /**
     * Overwrite header values given name
     *
     * @param   String  name   Header name
     * @param   String  value  Header value
     * @return  Void
     */

  }, {
    key: "set",
    value: function set(name, value) {
      wm(this)[normalizeName(name)] = [normalizeValue(value)];
    }
    /**
     * Iterate over all values
     *
     * @return  Iterator
     */

  }, {
    key: "values",
    value:
    /*#__PURE__*/
    _regeneratorRuntime.mark(function values() {
      var _iteratorNormalCompletion4, _didIteratorError4, _iteratorError4, _iterator4, _step4, _step4$value, name, value;

      return _regeneratorRuntime.wrap(function values$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _iteratorNormalCompletion4 = true;
              _didIteratorError4 = false;
              _iteratorError4 = undefined;
              _context3.prev = 3;
              _iterator4 = this[Symbol.iterator]();

            case 5:
              if (_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done) {
                _context3.next = 12;
                break;
              }

              _step4$value = _slicedToArray(_step4.value, 2), name = _step4$value[0], value = _step4$value[1];
              _context3.next = 9;
              return value;

            case 9:
              _iteratorNormalCompletion4 = true;
              _context3.next = 5;
              break;

            case 12:
              _context3.next = 18;
              break;

            case 14:
              _context3.prev = 14;
              _context3.t0 = _context3["catch"](3);
              _didIteratorError4 = true;
              _iteratorError4 = _context3.t0;

            case 18:
              _context3.prev = 18;
              _context3.prev = 19;

              if (!_iteratorNormalCompletion4 && _iterator4.return != null) {
                _iterator4.return();
              }

            case 21:
              _context3.prev = 21;

              if (!_didIteratorError4) {
                _context3.next = 24;
                break;
              }

              throw _iteratorError4;

            case 24:
              return _context3.finish(21);

            case 25:
              return _context3.finish(18);

            case 26:
            case "end":
              return _context3.stop();
          }
        }
      }, values, this, [[3, 14, 18, 26], [19,, 21, 25]]);
    })
    /**
     * The class itself is iterable
     * alies for headers.entries()
     *
     * @return  Iterator
     */

  }, {
    key: Symbol.iterator,
    value: function value() {
      return this.entries();
    }
    /**
     * Create the default string description.
     * It is accessed internally by the Object.prototype.toString().
     *
     * @return  String  [Object Headers]
     */

  }, {
    key: Symbol.toStringTag,
    get: function get() {
      return 'Headers';
    }
  }]);

  return Headers;
}();

module.exports = Headers;